import React, { useState, useEffect  } from 'react';
import { Button, Modal, Form } from 'react-bootstrap';

const ModalForm = ({ handleClose, question, answer, feedbackType }) => {
  const [showModal, setShowModal] = useState(true);
  const [country, setCountry] = useState('');
  const [organization, setOrganization] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [ipAddress, setIPAddress] = useState('');

   // Use setShowModal to toggle modal visibility
   const handleShowModal = () => setShowModal(!showModal);

   useEffect(() => {
    // Fetch and log IPAddress when FeedbackComponent mounts
    fetch('https://api.ipify.org?format=json')
      .then(response => response.json())
      .then(data => setIPAddress(data.ip))
      .catch(error => console.log(error))
  }, []);

  // On component mount, check if there is form data in localStorage
  useEffect(() => {
    const formData = localStorage.getItem("formData");
    if (formData) {
      // If there is form data in localStorage, do not show the modal
      setShowModal(false);
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!country) {
      alert('Please enter a country');
      return;
    }
     const timestamp = new Date();
     const formattedTimestamp = timestamp.toISOString();

    //const timestamp = new Date();  // Creates a new Date object with the current date and time
    //const epochTimestamp = Math.floor(new Date().getTime() / 1000);  // Converts the timestamp to epoch time (in seconds)

    const formData = {
      question: question,
      answer: answer,
      country: country,
      organization: organization,
      name: name,
      email: email,
      feedback: feedbackType,
      ipAddress: ipAddress,
   //   timestamp: new Date().toISOString(),
      timestamp: formattedTimestamp,
    };

    localStorage.setItem('formData', JSON.stringify(formData));

    handleShowModal();
  };

  return (
    <>
      <Modal show={showModal} onHide={handleShowModal}> 
        <Modal.Header closeButton>
          <Modal.Title>About You</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formCountry">
              <Form.Label>Country (Required)</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter country"
                value={country}
                onChange={(e) => setCountry(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group controlId="formOrganization">
              <Form.Label>Organization</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter organization"
                value={organization}
                onChange={(e) => setOrganization(e.target.value)}
              />
            </Form.Group>

            <Form.Group controlId="formName">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </Form.Group>

            <Form.Group controlId="formEmail">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Form.Group>

            <Button variant="primary" type="submit">
              Submit
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalForm;
